
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    liveRoomProductlist,
    liveRoomProductchooseRepositoryList,
    liveRoomProductonSale,
    liveRoomProductbatchEdit,
    liveRoomProductrepositoryJoin
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private radioType = 1
    private radioList = [
      {value:1,label:'直播间商品'},
      {value:2,label:'选择其他已入库商品'},
    ]
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    
    private tablelist2:any = []
    private tableloading2 = false
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private selectlist:any = []

    private mounted () {
      this.gettablelist()
    }

    private selectable(row){
      // return (this.selectlist.length + this.tablelist.length) < 6 || this.selectlist.find(v=>v.Id==row.Id)
      return true
    }
    private getkey(row){
      // console.log(row)
      return row.LiveRoomProductRepositoryId
    }
    private async joinstudio(e){
      if(!this.selectlist||!this.selectlist.length){
        this.$message.error('请先勾选要加入的商品 ')
        return
      }
      if((this.selectlist.length+this.tablelist.length) > 200){
        this.$message.error('直播间商品上限为200件 ')
        return
      }
      try{
        this.tableloading2 = true
        let data:any = {
          LiveRoomId:this.$route.query.Id,
          LiveRoomProductRepositoryIdList:this.selectlist.map(v=>v.LiveRoomProductRepositoryId),
          OnSale:await e
        }
        let res = await liveRoomProductrepositoryJoin(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
          this.gettablelist2()
          this.$nextTick(()=>{
            (this.$refs.table as any).clearSelection()
          })
        }
      }finally{
        this.tableloading2 = false
      }
    }
    private async operation(row){
      this.tableloading = true
      try{
        let data = await row
        let res = await liveRoomProductonSale({
          LiveRoomProductId:data.Id,
          OnSale:data.OnSale==1?0:1
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading2 = false
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          LiveRoomId:this.$route.query.Id,
          Name:this.keywords,

        }
        let res = await liveRoomProductlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.sort((a,b)=>{
            return a.SortAsc - b.SortAsc
          })
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist2(){
      try{
        this.tableloading2 = true
        let data = {
          LiveRoomId:this.$route.query.Id,
          Name:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        let res = await liveRoomProductchooseRepositoryList(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading2 = false
      }
    }
    private selectshop(list){
      // console.log(list.length)
      let that:any = this
      this.selectlist = list
      // console.log(1)
      if((this.selectlist.length+this.tablelist.length) > 200){
        // this:any
        that.$refs.table.toggleAllSelection()
        that.$message.closeAll()
        this.$message.error('直播间商品上限为200件 ')
        return
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist2()
    }
    private doSearch(){
      this.pageNo = 1
      if(this.radioType==1){
        this.gettablelist()
      }else{
        this.gettablelist2()
      }
    }
    private async save(){
      this.tableloading = true
      try{
        let data = {
          LiveRoomId:this.$route.query.Id,
          LiveRoomProductInfoList:this.tablelist
        }
        let res = await liveRoomProductbatchEdit(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private toback(){
      this.$router.go(-1)
    }
    private handleChange(e){
      this.keywords = ''
      this.pageNo = 1
      if(e==1){
        this.gettablelist()
      }else{
        this.gettablelist2()
        this.$nextTick(()=>{
          (this.$refs.table as any).clearSelection()
        })
      }
    }
  }
